function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["error"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { SELECTION_SERVICE_CLASSNAME } from '../plugin/FeatureDataPluginHandler';
import { FEATUREDATA_BUNDLE_ID } from './FeatureDataContainer';
import { showSelectToolPopup } from './SelectToolPopup';
import { Messaging, StateHandler, controllerMixin } from 'oskari-ui/util';
import { getFeatureId } from '../../../mapping/mapmodule/util/vectorfeatures';
export var DRAW_REQUEST_ID = 'FeatureData.featureselection';
export var DRAW_TOOLS = ['point', 'line', 'polygon', 'square', 'circle'];
export var SELECT_ALL_ID = -1;
var DRAW_REQUEST = {
  point: 'Point',
  line: 'LineString',
  polygon: 'Polygon',
  square: 'Square',
  circle: 'Circle'
};
var DRAW_OPTIONS = {
  allowMultipleDrawing: 'single'
};
var SelectToolPopupHandler = /*#__PURE__*/function (_StateHandler) {
  function SelectToolPopupHandler(instance) {
    var _this;
    _classCallCheck(this, SelectToolPopupHandler);
    _this = _callSuper(this, SelectToolPopupHandler);
    _this.instance = instance;
    _this.selectionService = null;
    _this.selectionPopup = null;
    _this.setState(_this.initState());
    _this.eventHandlers = _this.createEventHandlers();
    _this.addStateListener(function (state) {
      return _this.onStateUpdate(state);
    });
    return _this;
  }
  _inherits(SelectToolPopupHandler, _StateHandler);
  return _createClass(SelectToolPopupHandler, [{
    key: "getName",
    value: function getName() {
      return 'SelectToolPopupHandler';
    }
  }, {
    key: "initState",
    value: function initState() {
      var vectorLayers = this.getVectorLayers();
      return {
        layerId: this.getTopLayerId(vectorLayers),
        tool: null,
        vectorLayers: vectorLayers
      };
    }
  }, {
    key: "getTopLayerId",
    value: function getTopLayerId(vectorLayers) {
      var _vectorLayers;
      return (_vectorLayers = vectorLayers[vectorLayers.length - 1]) === null || _vectorLayers === void 0 ? void 0 : _vectorLayers.getId();
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this2 = this;
      var onMapLayerEvent = function onMapLayerEvent(evt) {
        if (!evt.getMapLayer().hasFeatureData()) {
          return;
        }
        var _this2$getState = _this2.getState(),
          current = _this2$getState.layerId;
        var vectorLayers = _this2.getVectorLayers();
        var layerId = current === SELECT_ALL_ID ? current : _this2.getTopLayerId(vectorLayers);
        _this2.updateState({
          vectorLayers: vectorLayers,
          layerId: layerId
        });
      };
      var handlers = {
        AfterMapLayerAddEvent: onMapLayerEvent,
        AfterMapLayerRemoveEvent: onMapLayerEvent,
        MapLayerVisibilityChangedEvent: onMapLayerEvent,
        AfterRearrangeSelectedMapLayerEvent: onMapLayerEvent,
        DrawingEvent: function DrawingEvent(evt) {
          if (!evt.getIsFinished() || !_this2.selectionPopup || DRAW_REQUEST_ID !== evt.getId()) {
            // only interested in finished own drawings when active
            return;
          }
          _this2.onFinishedDrawing(evt.getGeoJson().features[0]);
        }
      };
      var sb = this.instance.getSandbox();
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return sb.registerForEventByName(_this2, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var handler = this.eventHandlers[event.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [event]);
    }
  }, {
    key: "getVectorLayers",
    value: function getVectorLayers() {
      return this.instance.getSandbox().findAllSelectedMapLayers().filter(function (layer) {
        return layer.isVisible() && layer.hasFeatureData();
      });
    }
  }, {
    key: "setTool",
    value: function setTool(newTool) {
      var _this$getState = this.getState(),
        current = _this$getState.tool,
        vectorLayers = _this$getState.vectorLayers;
      if (!vectorLayers.length) {
        // tools are disabled
        return;
      }
      // toggle if already selected
      var tool = current === newTool ? null : newTool;
      if (tool) {
        this.startDrawing(tool);
      } else {
        this.stopDrawing();
      }
      this.updateState({
        tool: tool
      });
    }
  }, {
    key: "clearSelectionPopup",
    value: function clearSelectionPopup() {
      var resetTool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.selectionPopup) {
        this.selectionPopup.close();
      }
      if (resetTool) {
        var toolbarRequest = Oskari.requestBuilder('Toolbar.SelectToolButtonRequest');
        if (toolbarRequest) {
          this.instance.getSandbox().request(this.instance, toolbarRequest());
        }
      }
      this.stopDrawing();
      this.selectionPopup = null;
      this.updateState(this.initState());
    }
  }, {
    key: "setLayerId",
    value: function setLayerId(layerId) {
      this.updateState({
        layerId: layerId
      });
    }
  }, {
    key: "stopDrawing",
    value: function stopDrawing() {
      this.instance.getSandbox().postRequestByName('DrawTools.StopDrawingRequest', [DRAW_REQUEST_ID, true, true]);
    }
  }, {
    key: "startDrawing",
    value: function startDrawing(tool) {
      this.instance.getSandbox().postRequestByName('DrawTools.StartDrawingRequest', [DRAW_REQUEST_ID, DRAW_REQUEST[tool], DRAW_OPTIONS]);
    }
  }, {
    key: "clearFinishedDrawing",
    value: function clearFinishedDrawing() {
      var _this$getState2 = this.getState(),
        tool = _this$getState2.tool;
      this.stopDrawing();
      this.startDrawing(tool);
    }
  }, {
    key: "getSelectionService",
    value: function getSelectionService() {
      if (!this.selectionService) {
        this.selectionService = this.instance.getSandbox().getService(SELECTION_SERVICE_CLASSNAME);
      }
      return this.selectionService;
    }
  }, {
    key: "clearSelections",
    value: function clearSelections() {
      var _this$getSelectionSer;
      (_this$getSelectionSer = this.getSelectionService()) === null || _this$getSelectionSer === void 0 || _this$getSelectionSer.removeSelection();
    }
  }, {
    key: "onFinishedDrawing",
    value: function onFinishedDrawing(feature) {
      var _ref = feature || {},
        geometry = _ref.geometry;
      if (!geometry) {
        return;
      }
      var _this$getState3 = this.getState(),
        layerId = _this$getState3.layerId,
        vectorLayerIds = _this$getState3.vectorLayerIds;
      var layers = layerId === SELECT_ALL_ID ? vectorLayerIds : [layerId];
      var _this$instance$getMap = this.instance.getMapModule().getVectorFeatures({
          geometry: geometry
        }, {
          layers: layers
        }),
        error = _this$instance$getMap.error,
        layerData = _objectWithoutProperties(_this$instance$getMap, _excluded);
      var selectionService = this.getSelectionService();
      if (error || !selectionService) {
        Oskari.log(this.getName()).warn('Error querying features:', error || 'failed to get selection service');
        return;
      }
      Object.keys(layerData).forEach(function (layerId) {
        var _layerData$layerId;
        var fids = ((_layerData$layerId = layerData[layerId]) === null || _layerData$layerId === void 0 ? void 0 : _layerData$layerId.features.map(getFeatureId)) || [];
        selectionService.setSelectedFeatureIds(layerId, fids);
      });
      this.clearFinishedDrawing();
    }
  }, {
    key: "onStateUpdate",
    value: function onStateUpdate(state) {
      if (this.selectionPopup) {
        this.selectionPopup.update(state);
      }
    }

    /**
     * @method showSelectionTools
     * Handles tool button click -> opens selection tool dialog
     */
  }, {
    key: "showSelectionPopup",
    value: function showSelectionPopup() {
      var _this3 = this;
      if (this.selectionPopup) {
        return;
      }
      if (!this.getVectorLayers().length) {
        Messaging.warn(Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'selectionTools.noVectorLayers'));
      } else {
        // Set default draw mode active
        this.setTool(DRAW_TOOLS[0]);
      }
      var onClose = function onClose() {
        return _this3.clearSelectionPopup();
      };
      this.selectionPopup = showSelectToolPopup(this.getState(), this.getController(), onClose);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(SelectToolPopupHandler, ['setTool', 'setLayerId', 'clearSelections']);
export { wrapped as SelectToolPopupHandler };